import { SettingsGroupCard, SettingsHubPage, SettingsNavItem } from '../settings-shared';

export function SettingsIntegrationsPage() {
  return (
    <SettingsHubPage title="Интеграции">
      <SettingsGroupCard title="Данные">
        <SettingsNavItem
          title="Данные с Ozon"
          subTitle="Финансовые операции"
          to="/settings/integration/ozon-data"
          isLast
        />
      </SettingsGroupCard>
    </SettingsHubPage>
  );
}
